export const mapContainerStyle = {
  width: "100%",
  height: "600px",
};

export const defaultZoom = 12;